const REMINDER_OPTIONS = {
    NO_REMINDER: 4,
    EMAIL: 1,
    MAIL: 3,
    PHONE: 2,
    SMS: 5
};

export default {
    REMINDER_OPTIONS
};
